import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';


@Injectable()
export class AudioService {


  constructor(@Inject(DOCUMENT) private document: Document) {}

  playSound(sound: any) {
    if (sound.paused) {
      sound.play();
    } else {
      sound.currentTime = 0;
    }
  }

  loadAudio(audio: any, id: string) {
    audio = (this.document.getElementById(id) as HTMLAudioElement);
  }

}

